import { render } from "./CarPartGroups.vue?vue&type=template&id=fb77b704"
import script from "./CarPartGroups.vue?vue&type=script&lang=js"
export * from "./CarPartGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__